<template>
  <landing>
    <div class="form-container">
      <h4>{{ $t('welcomePage.login.title') }}</h4>

      <div class="content">
        <p>{{ $t('welcomePage.login.message') }}</p>

        <b-form-checkbox
          id="over-18"
          v-model="isOver18"
          name="over-18"
          @change="didToggleOver18"
        >
          {{ $t('welcomePage.login.adultDisclaimer') }}
        </b-form-checkbox>

        <div v-if="isOver18" id="firebaseui-auth-container"></div>
      </div>
      <div v-if="selectedSlmType === 'extra'" class="content download-app">
        <span class="line"></span>
        <p>
          Μπορείς να κατεβάσεις κατευθείαν το SLM Crew και να διαλέξεις βάρδιες
        </p>
        <download-mobile-app />
      </div>
    </div>
  </landing>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/analytics';
import 'firebase/auth';
import { auth as firauth } from 'firebaseui';
import 'firebaseui/dist/firebaseui.css';
import { mapState } from 'vuex';
import { googleWebClientID } from '@/helpers/firebaseConfig';

import Landing from '../components/Landing.vue';
import DownloadMobileApp from '../components/DownloadMobileApp.vue';

export default {
  name: 'Login',
  components: { Landing, DownloadMobileApp },
  data() {
    return {
      isOver18: false
    };
  },
  computed: {
    ...mapState(['selectedSlmType']),
    firUI() {
      let firUI = firauth.AuthUI.getInstance();
      if (!firUI) {
        firUI = new firauth.AuthUI(firebase.auth());
      }
      return firUI;
    }
  },
  methods: {
    didToggleOver18(value) {
      window.fbq('trackCustom', 'click_over_18', { isOver18: true });
      firebase.analytics().logEvent('click_over_18');

      if (value === true) {
        this.startFirUI();
      } else {
        this.resetFirUI();
      }
    },

    startFirUI() {
      const firUIConfig = {
        signInSuccessUrl: '/userdetails',
        signInOptions: [
          firebase.auth.FacebookAuthProvider.PROVIDER_ID,
          {
            provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
            clientId: googleWebClientID
          }
        ],
        credentialHelper: firauth.CredentialHelper.GOOGLE_YOLO,
        signInFlow: 'popup',
        callbacks: {
          signInSuccessWithAuthResult: () => {
            window.fbq('track', 'CompleteRegistration');
            firebase.analytics().logEvent('login');

            return true;
          }
        }
      };

      this.firUI.disableAutoSignIn();

      this.firUI.start('#firebaseui-auth-container', firUIConfig);
    },
    resetFirUI() {
      this.firUI.reset();
    }
  }
};
</script>

<style lang="scss" scoped>
$orange6: rgba(246, 139, 36, 0.6);
$textBlack6: rgb(33 37 41 / 60%);

.content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 2rem 1rem;

  p {
    font-weight: 200;
    text-align: center;
  }
}

#firebaseui-auth-container {
  margin-top: 1rem;
}

.download-app {
  padding-top: 0;
  margin-top: 0;

  .line {
    width: 100%;
    border-top: 1px solid $orange6;
    margin-bottom: 1rem;
  }
  p {
    color: $textBlack6;
  }
}
</style>
